import { $user_config } from "@/configs/user";
import { Injectable } from "@/di/injectable";

import { HttpService } from "./sxhr";

import type {
  PageBehaviorParams,
  ChannelParams,
  ChannelResult,
} from "@/interface/api";

@Injectable({ scope: "singleton", deep: [HttpService] })
export class PageService {
  http!: HttpService;
  constructor(http: HttpService) {
    this.http = http;
  }

  behavior(o: Omit<PageBehaviorParams, "anonymous_id">): Promise<null> {
    const info: PageBehaviorParams = {
      app_id: o.app_id,
      anonymous_id: $user_config.get("cookieId"),
      request_id: o.request_id,
      click_btn: o.click_btn,
      link_source: o.link_source,
      behavior: o.behavior,
    };
    return this.http.sxhr<PageBehaviorParams, null>({
      path: "api/interaction/behavior",
      data: info,
      keepalive: o.behavior === "leave" ? true : undefined,
    });
  }

  channel(o: string): Promise<ChannelResult> {
    const info: ChannelParams = {
      app_id: o,
    };
    return this.http.sxhr<ChannelParams, ChannelResult>({
      path: "api/skin/index",
      data: info,
    });
  }
}
